import { useQuery } from '@apollo/client';

import { ExternalCompanyLookupQueryDocument } from './externalCompanyLookupQuery.gql';

type CompanyLookupQueryVariables = {
  q: string;
};

export type ExternalCompany = {
  country: string;
  legalName: string;
  legalRegistrationNumber: string;
  legalVATNumber: null | string;
  street: string;
  zip: string;
  city: string;
};

type CompanyLookupQueryResult = {
  externalCompanyLookup: ExternalCompany[];
};

export const useCompanyLookupQuery = (searchInput: string) => {
  const variables = { q: searchInput };
  const {
    data,
    error,
    loading,
    refetch: queryRefetch,
  } = useQuery<CompanyLookupQueryResult, CompanyLookupQueryVariables>(
    ExternalCompanyLookupQueryDocument,
    {
      skip: !searchInput,
      variables,
    },
  );

  const companies = data?.externalCompanyLookup || [];
  const refetch = async () => queryRefetch(variables);

  return {
    companies,
    error,
    loading,
    refetch,
  };
};
